export const emailJsConfig = {
  serviceId: "service_q9l65oh",
  templateId: "template_a4igblk",
  userId: "user_3d7MTuDQQUn7JCbL1KeaE",
};

